"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CookiesWarning;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _Alert = _interopRequireDefault(require("@mui/material/Alert"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function CookiesWarning(props) {
  const {
    setcookiesDetailOpen,
    t,
    openSnackBar,
    agreeToCookies
  } = props;
  return /*#__PURE__*/_react.default.createElement(_material.Snackbar, {
    open: openSnackBar,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    style: {
      width: '100%'
    },
    severity: "info",
    action: /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      onClick: () => agreeToCookies()
    }, t('rgpd.agreed')), /*#__PURE__*/_react.default.createElement(_material.Button, {
      variant: "outlined",
      color: "primary",
      size: "small",
      onClick: () => setcookiesDetailOpen(true)
    }, t('rgpd.details')))
  }, t('rgpd.short_message')));
}